import { forwardRef, memo, ReactNode } from "react";
import classNames from "classnames";
import { default as ReactSlider, ReactSliderProps } from "react-slider";

import styles from "./style.module.scss";

export type SliderLabelMode = "none" | "bottom" | "topFloating";

export type SliderProps<T extends number | readonly number[] = number[]> = Omit<ReactSliderProps<T>, "onAfterChange"> & {
  labelPosition?: SliderLabelMode,
  formatLabelValue?: (valueNow: number) => ReactNode,
  labelClassName?: string,
  onImmediatelyChange?: ((value: T, index: number) => void) | undefined;
};

export const Slider = memo(forwardRef<ReactSlider<number[]>, SliderProps>((
  {
    labelPosition = "bottom",
    formatLabelValue = (value: number) => value + "%",
    className,
    thumbClassName,
    trackClassName,
    labelClassName,
    onChange,
    onImmediatelyChange,
    ...props
  },
  ref,
) => {
  return (
    <ReactSlider
      ref={ref}
      {...props}
      onChange={onImmediatelyChange}
      onAfterChange={onChange}
      className={classNames(styles.slider, styles[labelPosition as keyof typeof styles], className)}
      thumbClassName={classNames(styles.thumb, thumbClassName)}
      trackClassName={classNames(styles.track, trackClassName)}
      renderThumb={(props, state) => (
        <div {...props}>
          <span className={classNames(styles.label, labelClassName)}>
            {formatLabelValue?.(state.valueNow)}
          </span>
        </div>
      )}
    />
  );
}));